import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { EMaintenanceStatus } from '@shared/dto/app_info/e_maintenance_status';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { TYPE__class_constructor } from '@shared/types/TYPE__class_constructor';

export class CONSTANTS__shared {
  static readonly GRAPH_FIELD_HEIGHT_IMAGE = 6;

  static readonly IMAGE_METADATA_KEY_JSON_GRAPH = 'json_graph';

  static readonly ALLOWED_STATUSES_TO_GENERATION_START = [ENUM__generation_status.ADJUSTING, ENUM__generation_status.STOPPED, ENUM__generation_status.ERROR];

  static readonly IP_ADAPTER_IMAGES_LIMIT = 5;

  static readonly LATENTS_SCALE_MULTIPLIER = 8;

  static readonly GRID_CELL_SIZE = 24; //in px
  static readonly GRAPH_GRID_NODES_GAP_X = 10; //in cells
  static readonly GRAPH_GRID_NODES_GAP_Y = 5; //in cells

  static readonly SYMBOL_METADATA = Symbol.for('Symbol.metadata');

  static readonly URL_SOURCE_DELIMETER = '|';

  static IS_BROWSER = false;

  static readonly WAIT = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  static readonly GPU_NAME_CACHE = 'cache';

  static readonly IMAGE_LINE_GUIDANCE_BRIGHTNESS_THRESHOLD = 90;

  /*
   * APP INFO
   */

  static readonly ACTIVE_MAINTENANCE_STATUSES = [EMaintenanceStatus.ENABLED_TILL_RESTART_APP, EMaintenanceStatus.ENABLED_TILL_MANUAL_DISABLE];

  /*
   * CREDITS
   */
  static readonly PRICE_CREDITS_PER_IMAGE_TO_TEXT = 2;
  static readonly PRICE_CREDITS_PER_WORD_GET_RELATED_WORDS = 3;

  static readonly CREDITS_PER_USD_CENT_RATE = 10;

  static readonly CREDITS_GUARANTEED_PER_DAY_PERSONAL = 100;

  /*
   * ML ASSET
   */
  //tood: change to 1h
  static readonly ML_ASSET_RESERVATION_DURATION_DEFAULT = 1 * 60 * 1000; //in ms

  static readonly ML_ASSET_RESERVATION_FREE_TIMESTAMP_EXPIRED_AT = 4102444800 * 1000; //in ms, unix timestamp of 2100 year

  static readonly DIFFUSION_MODELS_TABLE_PAGE_ITEMS_AMOUNT = 100;

  /*
   * GRID2D VIRTUAL
   */
  static readonly GRID2D_VIRTUAL_TOTAL_COLUMNS_DEFAULT = 0;
  // 1 is min visible cells amount on page
  static readonly GRID2D_VIRTUAL_VISIBLE_CELLS_AMOUNT_DEFAULT = 1;

  static readonly GRID2D_VIRTUAL_CELL_TO_RENDER_ABSOULTE_DEFAULT = 0;

  /*
   * PUBLIC KNOWN ROUTES
   */

  static readonly ROUTE_MAGIC_LINK = '/auth/with_magic_link';
  static readonly ROUTE_VERIFICATE_EMAIL_AND_LOGIN = '/auth/verify_email_and_login';
  static readonly ROUTE_WORKSPACE_INVITATION = '/workspace/invitation';
  static readonly ROUTE_SETTINGS_USER = '/settings/user';

  static readonly SERIALIZATION_CLASS_FIELD_STATIC = '_class_name_static';
  static readonly SERIALIZATION_CLASS_FIELD_INSTANCE = '_class_name_instance';
  static readonly SHARE_FIELD_CLASS_NAME = 'class_name';

  static readonly NUMBER_EMPTY_VALUE = -1;

  static SUPPORTED_LANGUAGES = Object.values(ENUM__language_type).filter(
    language => language != ENUM__language_type.DEVELOPMENT && language != ENUM__language_type.EMPTY && language != ENUM__language_type.PIGDOG,
  );

  //todo: move to timings enum
  static readonly GENERATION_DURATION_ADJUSTING_STEP = 10;

  static readonly GRID2D_CHUNK_SIZE = 100;

  static readonly SEARCH_IMAGES_BATCH_LIMIT = 200;

  /*
   * USER ACHIEVMENT
   */

  static readonly USER_ACHIEVMENT_FAMILY = 10;
  static readonly USER_ACHIEVMENT_CLOSE_FRIENDS = 100;
  static readonly USER_ACHIEVMENT_FRIENDS = 1000;
  static readonly USER_ACHIEVMENT_EARLYBIRD = 10_000;

  static readonly IMAGES_ON_LOADER_SCREEN = 100;

  static readonly CLASS_MAPPING_REGISTERED_CLASSES: { [key: string]: TYPE__class_constructor } = {};

  static readonly IGNORED_TO_LOG_NETWORK_EVENTS_SERVER_TO_GENERATOR: string[] = [];
  static readonly IGNORED_TO_LOG_NETWORK_EVENTS_GENERATOR_TO_SERVER: string[] = [];

  static readonly NETWORK_EVENTS_AUTOMATED = [
    ENUM__network_event_client_to_server.PING,
    ENUM__network_event_client_to_server.PONG,
    ENUM__network_event_client_to_server.WORKSPACE_CHILD_ENTITY_UPDATE_VIEWER_STATUS,
  ];

  static readonly GENERATION_STATUS_FINISHED = [ENUM__generation_status.ERROR, ENUM__generation_status.STOPPED];

  static readonly UPLOAD_FILE_ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];

  //keep in mind that sizes of images increasing x3 in RAM or during sending via network
  static readonly UPLOAD_FILE_SIZE_MAX = 1024 * 1024 * 50;

  static readonly TOKEN_WORKSPACE_INVITATION_LINK_EMAIL = 'invite.by.link@ultimatediffusion.com';

  static readonly COOKIE_LANGUAGE = 'language';

  static readonly COOKIE_USER_AUTH_TOKEN = 'user_auth_token';
  static readonly COOKIE_USER_AUTH_TOKEN_DURATION = 60 * 10 * 1000;

  static readonly USER_PASSWORD_LENGTH_MIN = 6;

  static WORKSPACE_SPECIAL_COLLECTION_TYPES: ENUM__workspace_entity[] = [
    ENUM__workspace_entity.COLLECTION_UPLOADS,
    ENUM__workspace_entity.COLLECTION_GENERATED,
    ENUM__workspace_entity.COLLECTION_VIEWED_ON_SEARCH,
    ENUM__workspace_entity.COLLECTION_FAVORITES,
  ];

  static readonly WORKSPACE_LIMIT_PER_USER = 10;

  static readonly USER_DEFAULT_LANGUAGE = ENUM__language_type.EMPTY;
}
